import React from 'react';
import Status from './Onboarding/Status';
import Header from './Header';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';

function MainStatus() {
  return (
    <>
      <main>
        <MobileNavigation />

        <Status navbar={<Header />} />

        <Footer />
      </main>
    </>
  );
}

export default MainStatus;
